import styled from '@emotion/styled';
import { Icon, NakedButton } from '@qga/roo-ui/components';
import { themeGet } from 'styled-system';

const StyledButton = styled(NakedButton)`
  width: ${themeGet('space.8')};
  height: ${themeGet('space.8')};
  color: ${themeGet('colors.text.heading')};
  line-height: ${themeGet('space.6')};
  font-size: ${themeGet('fontSizes.sm')};
  border-radius: ${themeGet('components.pagination.button.borderRadius')};

  &:disabled,
  &:disabled:focus,
  &:disabled:hover {
    opacity: 1;
    svg {
      color: ${themeGet('colors.greys.smoke')};
    }
  }

  &.active,
  &.active:focus,
  &.active:hover {
    background-color: ${themeGet('colors.text.heading')};
    opacity: 1;
    font-weight: 700;
    color: ${themeGet('colors.text.inverse')};
  }
  &.active::after {
    content: '';
    display: block;
    position: absolute;
    height: 2px;
    width: 15px;
    margin-left: ${themeGet('space.2')};
    margin-top: 0;
    background-color: ${themeGet('colors.greys.charcoal')};
  }
`;

const PreviousIcon = () => (
  <Icon data-testid="previous-icon" name="chevronLeft" />
);

const NextIcon = () => <Icon data-testid="next-icon" name="chevronRight" />;

export interface PaginationItemProps {
  disabled?: boolean;
  isSelected?: boolean;
  itemVariant: 'next' | 'previous' | 'page';
  onItemChange: (pageNumber: number) => void;
  page: number;
}

const PaginationItem = ({
  page,
  itemVariant,
  isSelected,
  onItemChange,
  ...restProps
}: PaginationItemProps) => {
  return (
    <StyledButton
      {...restProps}
      className={isSelected ? 'active' : undefined}
      onClick={() => {
        onItemChange(page);
      }}
    >
      {itemVariant === 'page' && page}
      {itemVariant === 'next' && <NextIcon />}
      {itemVariant === 'previous' && <PreviousIcon />}
    </StyledButton>
  );
};

export default PaginationItem;
